import "../../../bryntum-lib/editors/clientsEditorV2/SwivuClientsEditorV2.jsx";
import SwivuModal from "./SwivuModal.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { useCallback } from "react";

const SwivuClientsEditorV2 = ({
  context,
  record,
  onClose,
  isShow,
  editorInstance
}) => {
  const { client, selectTabByTypeOnOpen, selectTabByDeepLinkSlugOnOpen, note, checklist, onSwivuTabOnRecordChangeHandler } = record || {};
  const onShowHandler = useCallback(
    (editor, otherParams = {}) => {
      /* Bug: Using Duplicate entity helper selecting an existing record and then opening a new editor causes previous editor to loose the selected record since react state is not updated with the widgets record.
      Fix: Assigning react state to bryntum's widget, lets us mutate react state from inside the widget instance.

      We are setting react state before invocation of editRecord because if a user opens a phantom record then through editRecord editor triggers a change event in all fields, if a field is using reactState property i.e, Duplicate Entity Helper then we might encounter errors. Therefore, setting reactState before editRecord trigger fixes these issues. */
      editorInstance.recordKey = "client"
      editor.reactState = editorInstance;

      editor.project = context.project;
      editor.editRecord(
        client,
        context,
        Object.assign(otherParams, { selectTabByTypeOnOpen, selectTabByDeepLinkSlugOnOpen, note, checklist, onSwivuTabOnRecordChangeHandler })
      );
      editorInstance.editorRef = editor;
    },
    [client, context, editorInstance]
  );
  return (
    <SwivuModal
      widgetType={WIDGET_KEYS.clientEditorV2Type}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  );
};

export default SwivuClientsEditorV2;
